(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mjp-cart-rewards"] && !Shopify.designMode) return;
  try {
    document.addEventListener('mjp:cart-updated', function (event) {
  const cart = event.detail;
  if (!cart || !Number.isFinite(cart.total_price)) return;
  document.querySelectorAll('.mjp-cart-rewards').forEach(function (panel) {
    if (cart.currency && cart.currency !== panel.dataset.currency) { panel.hidden = true; return; }
    panel.hidden = false;
    const money = new Intl.NumberFormat(panel.dataset.locale || 'fr', {style:'currency',currency:panel.dataset.currency});
    panel.querySelectorAll('[data-threshold]').forEach(function (card) {
      const threshold = Number(card.dataset.threshold);
      const missing = Math.max(0, threshold - cart.total_price);
      const done = missing === 0;
      card.classList.toggle('mjp-reward-done', done);
      const bar = card.querySelector('progress');
      bar.value = Math.min(100, cart.total_price * 100 / threshold);
      card.querySelector('.mjp-reward-heading span').textContent = done ? '✓' : card.dataset.remaining.replace('__AMOUNT__', money.format(missing / 100));
      card.querySelector('p').hidden = !done;
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
